import { createSlice } from "@reduxjs/toolkit"

import { stateEnum } from "../constants/enum.js"

const { stock } = stateEnum

const initialState = { 
}

// export const fetchStock = createAsyncThunk(
//   `${stock}/fetchStock`,
//   async ({ token, item_code, item_company }) => {
    
//     try {
//       const response = await axios.post(
//         apiRoute.stock.fetch,
//         {
//           item_code: item_code !== "" ? item_code : null,
//           item_company: item_company !== "" ? item_company : null,
//         },
//         {
//           headers: {
//             Authorization: "Bearer " + token,
//           },
//         }
//       )
//       return response.data.data
//     } catch (error) {
//       throw error
//     }
//   }
// )

// export const fetchStockItemDesc = createAsyncThunk(
//   `${stock}/fetchStockItemDesc`,
//   async ({ token }) => {
//     try {
//       const response = await axios.post(
//         apiRoute.stock.fetchItemMaster,
//         {
//           action: "Item_Master",
//         },
//         {
//           headers: {
//             Authorization: "Bearer " + token,
//           },
//         }
//       )
//       return response.data.data
//     } catch (error) {
//       throw error
//     }
//   }
// )

// export const fetchStockItemCompany = createAsyncThunk(
//   `${stock}/fetchStockItemCompany`,
//   async ({ token }) => {
//     try {
//       const response = await axios.post(
//         apiRoute.stock.fetchItemMaster,
//         {
//           action: "Item_Company",
//         },
//         {
//           headers: {
//             Authorization: "Bearer " + token,
//           },
//         }
//       )
//       return response.data.data
//     } catch (error) {
//       throw error
//     }
//   }
// )
  
const stockSlice = createSlice({
  name: stock,
  initialState,
  reducers: {
    resetStock: (state) => { 
    }, 
  }, 
})

export const { resetStock } = stockSlice.actions
export default stockSlice.reducer
